var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeguranca(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.95 68.1496C53.3843 68.1496 64.275 67.0191 64.275 65.6246C64.275 64.2301 53.3843 63.0996 39.95 63.0996C26.5157 63.0996 15.625 64.2301 15.625 65.6246C15.625 67.0191 26.5157 68.1496 39.95 68.1496Z",
    fill: "#5731FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4 11.875C32.7125 23.7875 15.625 20.3375 15.625 20.3375C15.625 57.4125 39.4 65.2 39.4 65.2C39.4 65.2 63.175 57.4125 63.175 20.3375C63.175 20.3375 46.0875 23.7875 39.4 11.875Z",
    fill: "white",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3254 24.5127C57.9254 50.5127 43.6379 59.1502 39.4004 61.1502V18.0127C43.6879 22.2627 49.9754 24.5502 57.6379 24.5502C58.2254 24.5502 58.7879 24.5377 59.3254 24.5127Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3998 18.0127V61.1502C35.0998 59.1502 20.8748 50.6127 19.4873 24.5127C20.0248 24.5377 20.5873 24.5502 21.1748 24.5502C28.8373 24.5502 35.1373 22.2627 39.4123 18.0127H39.3998Z",
    fill: "#FD9D00",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5379 47.2126C53.1879 42.7876 55.4504 36.8626 56.4254 28.9751C56.5504 27.9626 55.8254 27.0251 54.8129 26.9501C52.8129 26.8001 50.9004 26.5001 49.1004 26.0376C48.4129 25.8626 47.8254 26.5751 48.1379 27.2126C50.2379 31.4126 51.8004 37.8626 49.5129 46.7751C49.3504 47.4126 50.2004 47.7626 50.5379 47.2001V47.2126Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeguranca);
export default __webpack_public_path__ + "static/media/seguranca.b28b309f.svg";
export { ForwardRef as ReactComponent };